import Clear from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useStyles from './style';

const BackButton = ({ handleClose }: { handleClose?: () => void }) => {
  const classes = useStyles();

  const navigate = useNavigate();

  const defaultCloseHandler = () => {
    navigate(-1);
  };

  return (
    <IconButton
      onClick={handleClose || defaultCloseHandler}
      data-testid="xButton"
      style={{ backgroundColor: 'transparent' }}
      className={classes.icon}
    >
      <Clear
        style={{
          fontSize: 27,
        }}
      />
    </IconButton>
  );
};

BackButton.defaultProps = {
  handleClose: null,
};

export default BackButton;
